var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapboxgl-ctrl-bottom-left pl-2 pb-4",attrs:{"id":"legend"}},_vm._l((_vm.activeLayers),function(layer){return _c('div',{key:layer.name},[_vm._v(" "+_vm._s(_vm.layerMessage(layer))+" "),_c('v-legend',{attrs:{"layer":layer}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }